<div class="type-list px-3 py-1 custom-scroll-height-2" id="scrollContainerElement">

    <div class="list-filter py-3">
        <div class="search-box w-100 me-2">
            <input type="text" name="searchTerm" class="form-control" id="searchfilter" [(ngModel)]="searchText"
                (keyup.enter)="onSearch()" placeholder="{{ 'label-title.search' | translate }}" autocomplete="off" />
            <i class="ri-search-line search-icon"></i>
            <i class="mdi mdi-close-circle-outline clear-icon" *ngIf="searchText" (click)="clearSearch()"></i>
        </div>
    </div>

    @for(booking of bookingList ; track $index){
    <div class="pt-3 pb-3 border-bottom">
        <div class="d-flex justify-content-between">
            <div class="ride-type">
                <span class="me-2 font-weight-medium fs-12">
                    {{'heading-title.booking-no' | translate | uppercase}} {{booking.uniqueId}}
                </span>
                <span class="badge p-2 me-2"
                    [ngClass]="checkSchedule(booking.bookingTags) === this.helper.BookingType.SCHEDULE ? 'bg-danger-subtle text-danger' :'bg-info-subtle text-info'">
                    {{ checkSchedule(booking.bookingTags) === this.helper.BookingType.SCHEDULE ? ('label-title.schedule'
                    |
                    translate | uppercase) : 'label-title.asap' | translate | uppercase}}
                </span>
                <!-- @if (bookingHistoryMainType === helper.BookingHistoryMainType.RUNNING) { -->
                <span class="badge p-2 " [ngClass]="{
                        'bg-info-subtle text-info':
                          booking.status === helper.BookingStatus.ASSIGNED ||
                          booking.status === helper.BookingStatus.IN_ROUTE ||
                          booking.status === helper.BookingStatus.REQUESTED,
                        'bg-success-subtle text-success': booking.status === helper.BookingStatus.ACCEPTED || booking.status === helper.BookingStatus.ARRIVED_AT_DESTINATION,
                        'bg-primary-subtle text-primary':
                          booking.status === helper.BookingStatus.ARRIVED_AT_PICKUP ||
                          booking.status === helper.BookingStatus.STARTED ||
                          booking.status === helper.BookingStatus.ARRIVED_AT_STOP,
                        'bg-danger-subtle text-danger':
                          booking.status === helper.BookingStatus.NO_DRIVER_FOUND ||
                          booking.status === helper.BookingStatus.NOT_ANSWERED ||
                          booking.status === helper.BookingStatus.REJECTED ||
                          booking.status === helper.BookingStatus.CANCELLED
                      }">{{ getStatusString(booking.status) | translate }}
                </span>
                <!-- } -->
                @if(checkSchedule(booking.bookingTags) === this.helper.BookingType.SCHEDULE){
                <p class="text-danger booking-time mt-1 mb-0">
                    {{ 
                        helper.moment(booking.bookingTime)
                        .tz(helper.displayTimezone)
                        .format(helper.DATE_FORMAT.DD_MM_YY) 
                      }} 
                      {{ 
                        helper.moment(booking.bookingTime)
                        .tz(helper.displayTimezone)
                        .format(booking.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour) 
                      }}
                </p>
                }
            </div>
            <div class="time">
                <i>{{helper.moment(booking.createdAt).tz(helper.displayTimezone).format(booking?.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour)}}</i>
            </div>
        </div>
        <div class="pt-2">
            @if(booking.customerDetail){
            <div class="d-flex align-items-center justify-content-between mb-1">
                <h6 class="mb-0">{{'label-title.passenger-details' | translate}}</h6>
                <button class="btn btn-primary btn-sm" (click)="onViewDetails(booking)">{{'button-title.view-details' |
                    translate}}</button>
            </div>
            <div class="d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mb-3">
                <div class="service-type d-flex align-items-center">
                    <img [src]=" booking.customerDetail.imageUrl ? helper.IMAGE_URL + booking.customerDetail.imageUrl : helper.DefaultImages.DefaultUserImage"
                        alt="driver_profile" class="booking-image" (error)="handleImageError($event)" alt="">
                    <div class="type-name ms-3">
                        <h6 class="mb-0">{{booking.customerDetail?.name}}</h6>
                        <p class="mb-0">{{booking.customerDetail?.phone}}</p>
                    </div>
                </div>
                <div class="mt-3 mt-sm-0">
                    @if(booking?.bookingInvoice?.estimated?.total){
                    <div class="d-flex">
                        <h6 class="me-1">
                            {{'label-title.total-amount' | translate}} :
                        </h6>
                        <div>
                            <h6 class="d-flex currency-gap">
                                {{
                                booking?.bookingInvoice?.estimated?.total?.toFixed(booking?.bookingInvoice?.decimalPointValue)
                                }}
                                <span
                                    [ngClass]="{ 'order-first': booking.bookingInvoice?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                                    {{ booking.bookingInvoice?.currencySign }} </span>
                            </h6>
                        </div>
                    </div>
                    }
                </div>
            </div>
            }
            @if(booking.confirmedDriver){
            <h6 class="mb-1">{{'label-title.driver-details' | translate}}</h6>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap justify-content-between">
                <div class="service-type d-flex align-items-center">
                    <img [src]="booking.confirmedDriver.imageUrl ? helper.IMAGE_URL + booking.confirmedDriver.imageUrl : helper.DefaultImages.DefaultUserImage"
                        alt="driver_profile" class="booking-image" (error)="handleImageError($event)" alt="">
                    <div class="type-name ms-3">
                        <h6 class="mb-0">{{booking.confirmedDriver?.name}}</h6>
                        <p class="mb-0">{{booking.confirmedDriver?.phone}}</p>
                        <p class="mb-0">
                            {{ booking.confirmedDriver?.vehicleDetail?.brand }} | {{
                            booking.confirmedDriver?.vehicleDetail?.model }} |
                            {{ booking.confirmedDriver?.vehicleDetail?.color }} | {{
                            booking.confirmedDriver?.vehicleDetail?.plateNo }}</p>
                    </div>
                </div>
                <div class="mt-3 mt-sm-0">
                    @if(booking?.bookingInvoice?.estimated?.driverProfit){
                    <div class="d-flex">
                        <h6 class="me-1"> {{'label-title.driver-profit' | translate}} : </h6>

                        <div>

                            <h6 class="d-flex currency-gap">

                                {{
                                booking?.bookingInvoice?.estimated?.driverProfit?.toFixed(booking?.bookingInvoice?.decimalPointValue)
                                }}
                                <span
                                    [ngClass]="{ 'order-first': booking.bookingInvoice?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                                    {{
                                    booking.bookingInvoice?.currencySign }} </span>
                            </h6>
                        </div>
                    </div>
                    }
                </div>
            </div>
            }
            @if(booking.vehicleType){
            <h6 class="mb-1 mt-3">{{'label-title.vehicle-type' | translate}} : {{booking.vehicleType.name}} </h6>
            }
        </div>
    </div>
    }@empty {
    <div class="d-flex justify-content-center align-items-center" style="height: 90%;">
        {{'label-title.no-record-found' | translate}}
    </div>
    }

    <div class="text-center mt-3">
        <div class="text-success">
            @if(isHistoryLoading) {
            <i class="mdi mdi-loading mdi-spin fs-20 align-middle me-2"></i>
            }

        </div>
    </div>
</div>